import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  public id = 0;

  constructor(private router: Router) { }

  ngOnInit() {
  }

  SetActive(value) {
     console.log("setting active: " + value)
     this.id = value;
    
     if(this.id === 0) {
      this.router.navigate(['/Home']);
   
     }
     if(this.id === 1) {
      this.router.navigate(['/Projects']);
   
     }

     if(this.id === 2) {
      this.router.navigate(['/Services']);
   
     }

     if(this.id === 3) {
      this.router.navigate(['/About']);
   
     }

     if(this.id === 4) {
       this.router.navigate(['/ContactUs']);
     }

  }

}
